module.exports = __webpack_public_path__ + "static/media/expand-alt.b83e71b7.svg";